var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('filter-coach-form',{on:{"hide":_vm.onHide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }